import ConfigMatpel from "../../../../../components/categories/siakad/lms/data_matpel/subpage/config_matpel/Home";
export default function Home() {
  
  return (
    <ConfigMatpel />
  );
}
